import { isSchema, isSchemaInstance } from './utils';

export function clone<T>(original: T): T;
export function clone<T>(original: T, data: Record<string, any>): T;
export function clone<T>(original: T[]): T[];
export function clone<T>(original: T | T[], data: Record<string, any> = {}): T | T[] {
	if (Array.isArray(original)) {
		return original.map((item: T) => clone(item));
	}

	if (isSchemaInstance(original) && isSchema(original.constructor)) {
		const copy = new original.constructor();
		const fields = Object.getOwnPropertyNames(original);

		for (const field of fields) {
			if (data && field in data) {
				copy[field] = data[field];
			} else {
				copy[field] = clone((original as any)[field]);
			}
		}

		return copy;
	}

	return structuredClone(original);
}
